import {type Dispatch, type SetStateAction, useState} from 'react'

/**
 * Tracks whether the highlighted timeline event has been scrolled into view.
 * Resets back to `false` when the highlight target changes *and* the new target
 * is loaded — so a user navigating between highlighted events triggers a fresh
 * scroll. The reset is exposed in the same render so the scroll effect below
 * sees the updated value without an extra commit.
 */
export function useHasScrolledForHighlight(
  isHighlightLoaded: boolean,
  highlightedEventId: string | undefined,
  lastScrolledItemId: string | undefined,
): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [hasScrolled, setHasScrolled] = useState(false)
  if (hasScrolled && isHighlightLoaded && lastScrolledItemId !== highlightedEventId) {
    setHasScrolled(false)
    return [false, setHasScrolled]
  }
  return [hasScrolled, setHasScrolled]
}
